"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.nominalMatch = void 0;
const constants_js_1 = require("./constants.js");
function nominalMatch(a, b) {
    if (typeof a === 'object' && a !== null && typeof b === 'object' && b !== null)
        return a[constants_js_1.typeSym] === b[constants_js_1.typeSym];
    else {
        return true;
    }
}
exports.nominalMatch = nominalMatch;
//# sourceMappingURL=nominal_match.js.map